import {
  createContext,
  MutableRefObject,
  PropsWithChildren,
  ReactElement,
  useContext,
} from 'react';
import { useGridApiRef, GridApiPro } from '@mui/x-data-grid-pro';

const DataGridApiContext =
  createContext<MutableRefObject<GridApiPro | null> | null>(null);

export function WithDataGridApi({
  children,
}: PropsWithChildren<{}>): ReactElement {
  const apiRef = useGridApiRef();

  return (
    <DataGridApiContext.Provider value={apiRef}>
      {children}
    </DataGridApiContext.Provider>
  );
}

export function useDataGridApi(): MutableRefObject<GridApiPro | null> {
  const apiRef = useContext(DataGridApiContext);
  if (!apiRef) {
    throw new Error(
      'useDataGridApi must be used within DataGridApiProvider'
    );
  }
  return apiRef;
}
